import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import orderService from "../Services/orderService";
import moment from "moment";
import CustomerCredit from "../Modals/CustomerCredit";
import Loading from "../Modals/Loading";
import ReceivableService from "../Services/receivableService";
import { Link } from "react-router-dom";
import DateRangePicker from "../Components/DateRangePicker";

const CustomerLedger = () => {
  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [receivables, setReceivables] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [showReceived, setShowReceived] = useState(false);

  const OpenModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const getReceivables = async () => {
    try {
      const response = await ReceivableService.fetchByCustomer(
        params.get("id"),
      );
      setReceivables(response.receivables);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getReceivables();
  }, []);

  useEffect(() => {
    const getCustomerLedger = async () => {
      try {
        setLoading(true);
        const response = await orderService.fetchCustomerLedger(
          params.get("id"),
        );

        // Set customer and ledger data separately
        setCustomer(response.customer);
        setLedger(response.ledger);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching customer ledger:", error);
        setLoading(false);
      }
    };
    getCustomerLedger();
  }, []);

  useEffect(() => {
    const getCustomerLedgerByDate = async () => {
      try {
        setLoading(true);
        const response = await orderService.fetchCustomerLedgerByDate(
          params.get("id"),
          { start_date, end_date },
        );
        // Set customer and ledger data separately
        setCustomer(response.customer);
        setLedger(response.ledger);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching customer ledger:", error);
        setLoading(false);
      }
    };
    if (start_date.length > 0 && end_date.length > 0) {
      getCustomerLedgerByDate();
    }
  }, [start_date, end_date]);

  const clearCheck = async (id) => {
    ReceivableService.clear(id).then(() => {
      getReceivables();
    });
  };

  // const totalDebit = ledger.reduce((acc, entry) => {
  //   return entry.type === "ORDER" ? acc + parseFloat(entry.vat_amount || 0) : acc;
  // }, 0);

  const totalDebit = ledger.reduce((acc, entry) => {
    if (
      entry.type === "ORDER" &&
      ["readytodeliver", "dispatched", "deliveredorders"].includes(entry.status)
    ) {
      return acc + parseFloat(entry.vat_amount || 0);
    }
    return acc;
  }, 0);

  const totalCredit = ledger.reduce((acc, entry) => {
    return entry.type === "TRANSACTION"
      ? acc + parseFloat(entry.amount || 0)
      : acc;
  }, 0);

  const finalBalance = totalDebit - totalCredit;

  //const totalReceivable = receivables.reduce((acc, curr) => acc + parseFloat(curr.amount || 0), 0);

  const totalReceivable = receivables.reduce((acc, curr) => {
    return curr.status === "PENDING" ? acc + parseFloat(curr.amount || 0) : acc;
  }, 0);
  const adjustedBalance = finalBalance - totalReceivable;

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg min-h-[calc(100vh-48px)] bg-white">
      {loading ? (
        <Loading />
      ) : (
        <>
          {customer && (
            <div>
              <div className="flex flex-row justify-between">
                {" "}
                <p className="font-bold text-3xl text-secondary">
                  Customer Ledger
                </p>
                <Link
                  to="customerpdfinvoice"
                  state={{
                    customer,
                    ledger,
                    totalDebit,
                    totalCredit,
                    finalBalance,
                    adjustedBalance,
                    receivables,
                  }}
                >
                  <button className="button-primary">PDF Ledger</button>
                </Link>
              </div>
              <div className="bg-white border shadow-md w-[40%] p-6 mt-10 rounded-3xl">
                <div className="flex flex-row gap-3 items-center">
                  <div className="text-cyan-700 text-xl font-semibold flex flex-row items-center gap-2">
                    <h1>{customer.company_name}</h1>
                  </div>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-4">
                  <p>
                    Email:{" "}
                    <span className="font-semibold text-gray-700">
                      {customer.email}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Phone no:{" "}
                    <span className="font-semibold text-gray-700">
                      {customer.phone_number}
                    </span>
                  </p>
                </div>
                <div className="text-sm font-medium text-gray-400 mt-2">
                  <p>
                    Address:{" "}
                    <span className="font-semibold text-gray-700">
                      {customer.address}
                    </span>
                  </p>
                </div>
              </div>

              <div className="mt-10">
                <div className="flex justify-end gap-4">
                  <button
                    onClick={() => setShowDetails((prev) => !prev)}
                    className="flex items-center gap-2 text-xs font-semibold px-4 py-2 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 hover:shadow transition-all duration-300"
                  >
                    <svg
                      className={`w-4 h-4 transition-transform duration-300 ${showDetails ? "rotate-180" : ""}`}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                    {showDetails ? "Hide Details" : `Show Details`}
                  </button>
                  <DateRangePicker
                    onRangeChange={({ start, end }) => {
                      setStartDate(start);
                      setEndDate(end);
                    }}
                  />
                </div>

                <div
                  className={`transition-all duration-500 overflow-hidden ${showDetails ? "opacity-100 mt-4" : "max-h-0 opacity-0"}`}
                >
                  <div className="table-div">
                    <table>
                      <thead>
                        <tr className="border-y-2 text-left w-full text-black text-[10px]">
                          <th className="rounded-l-xl py-3 pl-4 w-[1%]">
                            Date
                          </th>
                          <th className="py-3 pl-4 w-[1%]">Order No.</th>
                          <th className="py-3 pl-4 w-[1%]">Reference</th>
                          <th className="py-3 pl-4 w-[2%]">Note</th>
                          <th className="py-3 pl-4 w-[1%]">Debit</th>
                          <th className="py-3 pl-4 w-[1%]">Credit</th>
                          <th className="py-3 pl-4 w-[1%]">Balance</th>
                          <th className="rounded-r-xl py-3 pl-4 w-[1%]">
                            Order Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ledger.map((entry, index) => (
                          <tr
                            key={index}
                            className={`border-b border-gray-100 text-left ${
                              index % 2 === 0 ? "bg-gray-50" : "bg-accent"
                            }`}
                          >
                            <td className="py-2 pl-4 text-primary font-bold w-[1%]">
                              {entry.order_date
                                ? moment(entry.order_date).format("ll")
                                : moment(entry.date).format("ll")}
                            </td>
                            <td className="py-2 pl-4 text-gray-700 font-light w-[1%]">
                              GAP-{entry.id || "-"}
                            </td>
                            <td className="py-2 pl-4 text-gray-700 font-light w-[1%]">
                              {entry.reference_no || "-"}
                            </td>
                            {/* <td className="py-2 pl-4 text-gray-700 font-light w-[2%]">
                          {entry.type === "ORDER"
                            ? `Order ${entry.invoice}`
                            : `Payment for Order ${entry.invoice}`}
                        </td> */}
                            <td className="py-2 pl-4 text-gray-700 font-light w-[2%] pr-4">
                              {entry.note || "-"}- Order No. {entry.order_id}
                            </td>
                            <td className="py-2 pl-4 font-medium w-[1%]">
                              {entry.type === "ORDER" ? entry.vat_amount : "-"}
                            </td>
                            <td className="py-2 pl-4 font-medium w-[1%]">
                              {entry.type === "TRANSACTION"
                                ? entry.amount
                                : "-"}
                            </td>
                            <td className="py-2 pl-4 font-light w-[1%]">
                              {parseFloat(entry.balance).toFixed(2)}
                            </td>
                            <td className="py-2 pl-4 font-light w-[1%]">
                              <div className="flex justify-left">
                                <div
                                  className={`px-2 py-1 rounded-md font-semibold bg-opacity-20 ${
                                    entry.status === "pending"
                                      ? "text-yellow-500 bg-yellow-500"
                                      : entry.status === "confirmed"
                                        ? "text-blue-500 bg-blue-500"
                                        : entry.status === "underprocess"
                                          ? "text-red-500 bg-red-500"
                                          : entry.status === "readytodeliver"
                                            ? "text-amber-500 bg-amber-500"
                                            : entry.status === "dispatched"
                                              ? "text-purple-500 bg-purple-500"
                                              : entry.status ===
                                                  "deliveredorders"
                                                ? "text-green-500 bg-green-500"
                                                : ""
                                  }`}
                                >
                                  {entry.status === "pending"
                                    ? "Pending"
                                    : entry.status === "confirmed"
                                      ? "Confirmed"
                                      : entry.status === "underprocess"
                                        ? "Under Process"
                                        : entry.status === "readytodeliver"
                                          ? "Ready To Deliver"
                                          : entry.status === "dispatched"
                                            ? "Dispatched"
                                            : entry.status === "deliveredorders"
                                              ? "Delivered"
                                              : ""}
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                        <tr className="text-[12px] text-lg bg-slate-200 font-semibold text-teal-600 pt-4">
                          <td className="py-3 pl-4">Total</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td className="py-3 pl-4">{totalDebit.toFixed(2)}</td>
                          <td className="py-3 pl-4">
                            {totalCredit.toFixed(2)}
                          </td>
                          <td className="py-3 pl-4">
                            {finalBalance.toFixed(2)}
                          </td>
                          <td className="py-3 pl-4"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <hr className="mt-10" />
              {receivables && receivables.length > 0 && (
                <>
                  <div className="flex flex-row justify-between items-center mt-10">
                    <p className="font-semibold text-secondary text-2xl">
                      Received
                    </p>
                    <button
                      onClick={() => setShowReceived((prev) => !prev)}
                      className="flex items-center gap-2 text-xs font-semibold px-4 py-2 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 hover:shadow transition-all duration-300"
                    >
                      <svg
                        className={`w-4 h-4 transition-transform duration-300 ${showReceived ? "rotate-180" : ""}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                      </svg>
                      {showReceived ? "Hide Details" : `Show Details`}
                    </button>
                  </div>
                  <div
                    className={`transition-all duration-500 overflow-hidden ${showReceived ? "opacity-100 mt-4" : "max-h-0 opacity-0"}`}
                  >
                    <div className="table-div">
                      <table>
                        <thead>
                          <tr className="border-y-2 text-left w-full text-black text-[10px]">
                            <th className="rounded-tl-lg w-[4%] py-3 pl-4">
                              Customer Name
                            </th>
                            <th className="w-[3%] py-3">Cheque No</th>
                            <th className="w-[2%] py-3">Bank Name</th>
                            <th className="w-[2%] py-3">Amount</th>
                            <th className="w-[4%] py-3">Presentable Date</th>
                            <th className="rounded-tr-lg w-[4%] text-center">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {receivables.map((value, index) => (
                            <tr
                              key={index}
                              className={`text-left text-[12px] duration-300 border-b border-gray-100 ${
                                index % 2 === 0 ? "bg-gray-50" : "bg-accent"
                              }`}
                            >
                              <td className="py-2 w-[2%] font-bold pl-4">
                                {value.customer_name}
                              </td>
                              <td className="py-2 w-[3%]">{value.number}</td>
                              <td className="py-2 w-[3%] font-semibold">
                                {value.bank}
                              </td>
                              <td className="py-2 w-[3%] font-bold">
                                {value.amount}
                              </td>
                              <td className="py-2 w-[3%]">
                                {moment(value.payable).format("ll")}
                              </td>
                              <td className="py-2 w-[3%]">
                                <div className="flex justify-center">
                                  <p
                                    className={`${
                                      value.status === "CLEARED"
                                        ? "bg-green-500 text-green-500"
                                        : "bg-red-500 text-red-500"
                                    } text-center rounded-md font-semibold uppercase px-4 py-1 bg-opacity-20`}
                                  >
                                    {value.status}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}

              <div className="flex flex-row justify-center gap-4 mt-4 flex-wrap">
                {[
                  {
                    label: "Total Received",
                    value: totalReceivable.toFixed(2),
                  },
                  { label: "End Balance", value: finalBalance.toFixed(2) },
                  {
                    label: "Adjusted Balance (After Cheque Received)",
                    value: `${adjustedBalance.toFixed(2)} AED`,
                  },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="flex flex-col bg-gray-50 border border-gray-200 rounded-xl px-5 py-3"
                  >
                    <span className="text-[10px] text-gray-400 uppercase tracking-wide font-semibold">
                      {stat.label}
                    </span>
                    <span className="text-sm font-bold text-gray-800 mt-1">
                      {stat.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      <CustomerCredit
        isOpen={isModalOpen}
        onClose={closeModal}
        customer={params.get("id")}
      />
    </main>
  );
};

export default CustomerLedger;
